/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Application_Phase_HintInputs */

const en_admin_application_phase_hint = /** @type {(inputs: Admin_Application_Phase_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When this toggle is enabled, new applications can be submitted. When it is disabled, job postings remain visible, but new applications are rejected by the server.`)
};

const de_admin_application_phase_hint = /** @type {(inputs: Admin_Application_Phase_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der Schalter aktiviert, können neue Bewerbungen eingereicht werden. Ist er deaktiviert, bleiben Stellenanzeigen sichtbar, neue Bewerbungen werden jedoch serverseitig abgelehnt.`)
};

/**
* | output |
* | --- |
* | "When this toggle is enabled, new applications can be submitted. When it is disabled, job postings remain visible, but new applications are rejected by the se..." |
*
* @param {Admin_Application_Phase_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_application_phase_hint = /** @type {((inputs?: Admin_Application_Phase_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Application_Phase_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_application_phase_hint(inputs)
	return en_admin_application_phase_hint(inputs)
});